module.exports = __webpack_public_path__ + "media/images/countryrect/mt-99c87501166f42584c7dbc27ee967670.svg";